import Cookies from 'js-cookie';
import { ADMITAD_ENABLED, DEV_URL, INTL_URL } from 'const';
import { Language } from 'models';
import { CountryCodeModel } from 'domains/cartography';

export class FEHeadersCookiesUtil {
  static setCountryCode(countryCode: CountryCodeModel | null) {
    if (countryCode !== null) {
      Cookies.set('countryCode', JSON.stringify(countryCode), {
        path: '/',
        domain:
          process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
        secure: true
      });
    }
  }
  static clearCountryCode() {
    Cookies.remove('countryCode');
  }
  static get getCountryCode(): CountryCodeModel | null {
    const countryCodeString = Cookies.get('countryCode');
    if (!countryCodeString) return null;

    return JSON.parse(countryCodeString) as CountryCodeModel;
  }

  static setPhoneMask(mask: string) {
    Cookies.set('phoneMask', mask, {
      path: '/',
      domain:
        process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
      secure: true
    });
  }

  static setUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    
    if (utmSource) {
      Cookies.set('a_utm_source', utmSource, {
        path: '/',
        domain: process.env.NODE_ENV === 'production' ? `.${DEV_URL}` : undefined,
        secure: true
      });
    }
    if (utmMedium) {
      Cookies.set('a_utm_medium', utmMedium, {
        path: '/',
        domain: process.env.NODE_ENV === 'production' ? `.${DEV_URL}` : undefined,
        secure: true
      });
    }
    if (utmCampaign) {
      Cookies.set('a_utm_campaign', utmCampaign, {
        path: '/',
        domain: process.env.NODE_ENV === 'production' ? `.${DEV_URL}` : undefined,
        secure: true
      });
    }
  }

  static setAdmintaduid() {
    if (!ADMITAD_ENABLED) {
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const admintaduid = urlParams.get('admitad_uid')?.trim();
    if (admintaduid) {
      Cookies.set('admitad_uid', admintaduid, {
        path: '/',
        domain: process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
        secure: true,
        expires: 90,
      });
    }
  }

  static getAdmintaduid() {
    if (!ADMITAD_ENABLED) {
      return undefined;
    }
    const value = Cookies.get('admitad_uid')?.trim();
    return value || undefined;
  }

  static getUTMParams() {    
    return {
      utm_source: Cookies.get('a_utm_source'),
      utm_medium: Cookies.get('a_utm_medium'),
      utm_campaign: Cookies.get('a_utm_campaign'),
    };
  }

  static clearPhoneMask() {
    Cookies.remove('phoneMask');
  }
  static get getPhoneMask(): string | null {
    return Cookies.get('phoneMask') || null;
  }

  static setCode(code: string) {
    Cookies.set('code', code, {
      path: '/',
      domain:
        process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
      secure: true
    });
  }
  static get getCode() {
    return Cookies.get('code');
  }
  static setSign(sign: string) {
    Cookies.set('sign', sign, {
      path: '/',
      domain:
        process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
      secure: true
    });
  }
  static get getSign() {
    return Cookies.get('sign');
  }

  static clearCode() {
    Cookies.remove('code', {
      path: '/',
      domain:
        process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
    });
  }
  static clearSign() {
    Cookies.remove('sign', {
      path: '/',
      domain:
        process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
    });
  }

  static setPhone(phone: string) {
    Cookies.set('phone', phone, {
      path: '/',
      domain:
        process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
      secure: true
    });
  }
  static get getPhone() {
    return Cookies.get('phone');
  }

  static setLanguage(lng: Language) {
    Cookies.set('language', lng, {
      path: '/',
      domain:
        process.env.NODE_ENV === 'production' ? `.${INTL_URL}` : undefined,
      secure: true
    });
  }
  static get getLanguage() {
    return Cookies.get('language') as Language | undefined;
  }
}
